// extracted by mini-css-extract-plugin
export default {"bar":"TabsBar_bar__u0qzU","menu_item":"TabsBar_menu_item__lJhMn","active":"TabsBar_active__4KtO9"};